
import { css } from 'lit';
export default css`
.location-map {
  position: absolute;
  bottom: 0px;
  top: 0px;
  right: 0px;
  left: 0px;
  display: flex;
  width: 100%;
  flex-direction: column;
  overflow: hidden;
}

  @media (min-width: 1024px) {.location-map {
    left: 60%;
    width: 54%;
  }
  }

  .location-map__static-map {
  position: absolute;
}

  .location-map__static-map {
    width: 1366px;
    height: 563px;
    right: 0px;
  }

  @media screen and (max-width: 1066px) {

  .location-map__static-map {
      right: -300px
  }
    }

  .location-map__map-container {
  width: 100%;
}

  .location-map__map-container {
    height: 565px;
    height: var(--hf-location-map-height, 565px);
  }

  .location-map__map-card {
  position: absolute;
}

  .location-map__map-card {
    top: 50%;
    transform: translateY(-50%);
    right: 3%
  }

  @media (max-width: 767px) {

  .location-map__map-card {
    left: 0px;
    right: 0px;
  }
}

  @media (max-width: 767px) {

  .location-map__map-card {
    top: 0px;
  }
}

  @media (min-width: 1024px) {

  .location-map__map-card {
      right: 8%
  }
    }

  @media (min-width: 1200px) {

  .location-map__map-card {
      right: 20%
  }
    }

  @media (min-width: 1600px) {

  .location-map__map-card {
      right: 25%
  }
    }

  .location-map__map-image {
    right: 0;
    width: 1366px;
    height: 563px;
    -o-object-fit: none;
       object-fit: none;
  }

  .location-map__map-icon {
  position: absolute;
}

  .location-map__map-icon {
    width: 24px;
    height: 24px;
  }

  .location-map__map-icon__text {
  font-size: 0.875rem;
}

  .location-map__map-icon__text {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}

  .location-map__close-button {
  position: absolute;
}

  .location-map__close-button {
  right: 0px;
}

  .location-map--block-small, .location-map--block {
  position: relative;
}

  .location-map--block-small,
  .location-map--block {
    left: 0;
    width: 100vw;
    margin-left: calc(50% - 50vw);
    height: 565px;
  }

  .location-map--block-small:before, .location-map--block:before {
  position: absolute;
}

  .location-map--block-small:before, .location-map--block:before {
  left: 0px;
}

  .location-map--block-small:before, .location-map--block:before {
  right: 0px;
}

  .location-map--block-small:before, .location-map--block:before {
  top: 0px;
}

  .location-map--block-small:before, .location-map--block:before {
  bottom: 0px;
}

  .location-map--block-small:before, .location-map--block:before {
  z-index: 10;
}

  .location-map--block-small:before, .location-map--block:before {
  background-color: transparent;
}

  .location-map--block-small:before, .location-map--block:before {
      content: '';
    }

  .location-map--block-small .location-map__map-container, .location-map--block .location-map__map-container {
      height: 160px;
      width: 30%;
    }

  @media (min-width: 768px) {

  .location-map--block-small .location-map__map-container, .location-map--block .location-map__map-container {
        width: 100%;
        height: 565px;
        height: var(--hf-location-map-height, 565px)
    }
      }

  .location-map--block-small .location-map__map-card, .location-map--block .location-map__map-card {
  bottom: 0px;
}

  .location-map--block-small .location-map__map-card, .location-map--block .location-map__map-card {
  z-index: 20;
}

  .location-map--block-small .location-map__map-card, .location-map--block .location-map__map-card {
  height: 100%;
}

  .location-map--block-small .location-map__map-card, .location-map--block .location-map__map-card {
  transform: none;
}

  @media (min-width: 768px) {

  .location-map--block-small .location-map__map-card, .location-map--block .location-map__map-card {
        transform: translateY(-50%);
        height: auto
    }
      }

  .location-map--block-small {
    left: auto;
    right: 0;
    position: relative;
    width: 100%;
    margin-left: initial;
    margin-bottom: 40px;
    height: auto;
  }

  .location-map--block-small .hidden-accessible-element {
      display: none;
    }

  .location-map--block-small .location-map__map-container {
      height: 180px;
      width: 100%;
    }

  @media (min-width: 768px) {

  .location-map--block-small .location-map__map-container {
        height: 565px;
        height: var(--hf-location-map-height, 565px);
        margin-bottom: 0
    }
      }

  @media (min-width: 768px) {

  .location-map--block-small {
      height: 280px;
      margin: auto
  }
    }

  @media (min-width: 1024px) {

  .location-map--block-small {
      height: 520px
  }
    }
`;